module.exports = __webpack_public_path__ + "static/media/view category.ffc46bea.svg";